import { ApiReadLanderResponse, ApiSimpleComponent } from "@incendium/api";
import { CallbackOrVal } from "Interfaces";
import { createContext, ReactNode, useContext, useMemo, useState } from "react";

interface LightningLanderContextType {
  component: ApiSimpleComponent;
  setComponent: (v: CallbackOrVal<ApiSimpleComponent>) => void;
  lander: ApiReadLanderResponse;
  setLander: (v: CallbackOrVal<ApiReadLanderResponse>) => void;
}

const LightningLanderContext = createContext<LightningLanderContextType>({
  component: {},
  setComponent: () => { },
  lander: {},
  setLander: () => { },
});

export const useLightningLanderContext = () =>
  useContext(LightningLanderContext);

const LightningLanderProvider = ({ children }: { children: ReactNode }) => {
  const [component, setComponent] = useState<ApiSimpleComponent>({});
  const [lander, setLander] = useState<ApiReadLanderResponse>({});
  const contextValue = useMemo(
    () => ({ component, setComponent, lander, setLander }),
    [component, lander]
  );
  return (
    <LightningLanderContext.Provider value={contextValue}>
      {children}
    </LightningLanderContext.Provider>
  );
};

export default LightningLanderProvider;
